import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { Objective } from '../../_models';
import { LmsService } from './lms.service';

@Injectable({
  providedIn: 'root'
})
export class ObjectiveService {
  private apiUrl = `${environment.apiUrl}/Objective`;
  constructor(private http: HttpClient) {
  }

  getBySubjectIdAndSectionSubjectIdAndParentId(subjectId: number, sectionSubjectId: number, parentId: number): Observable<Objective[]> {
    const query = `?sectionSubjectId=${sectionSubjectId ? sectionSubjectId : ''}&parentId=${parentId ? parentId : ''}`;
    return this.http.get<Objective[]>(`${this.apiUrl}/GetBySubjectIdAndSectionSubjectIdAndParentId/${subjectId}${query}`);
  }

  getTopByCurriculumId(curriculumId: number): Observable<Objective[]> {
    return this.http.get<Objective[]>(`${this.apiUrl}/GetTopByCurriculumId/${curriculumId}`);
  }

  getTopWithChildrenBySubjectIdAndSectionSubjectId(subjectId: number, sectionSubjectId: number): Observable<Objective[]> {
    return this.http.get<Objective[]>(
      `${this.apiUrl}/GetTopWithChildrenBySubjectIdAndSectionSubjectId/${subjectId}${sectionSubjectId ? '/' + sectionSubjectId : ''}`);
  }


  getTopByObjectiveLevelIdAndSubjectIdAndSectionSubjectId(objectiveLevelId: number, subjectId: number, sectionSubjectId: number): Observable<Objective[]> {
    return this.http.get<Objective[]>(
      `${this.apiUrl}/GetTopByObjectiveLevelIdAndSubjectIdAndSectionSubjectId/${objectiveLevelId}/${subjectId}${sectionSubjectId ? '/' + sectionSubjectId : ''}`);
  }

  getTopThatHaveLastChildrenBySectionSubjectId(sectionSubjectId: number): Observable<Objective[]> {
    return this.http.get<Objective[]>(`${this.apiUrl}/GetTopThatHaveLastChildrenBySectionSubjectId/${sectionSubjectId}`);
  }

  getTopByCurriculumIdWithObjectives(curriculumId: number): Observable<Objective[]> {
    return this.http.get<Objective[]>(`${this.apiUrl}/GetTopByCurriculumIdWithObjectives/${curriculumId}`);
  }

  getTopByCurriculumIdAndObjectiveLevelId(curriculumId: number, objectiveLevelId: number): Observable<Objective[]> {
    return this.http.get<Objective[]>(`${this.apiUrl}/GetTopByCurriculumIdAndObjectiveLevelId/${curriculumId}/${objectiveLevelId}`);
  }

  getChildObjectives(parentId: number): Observable<Objective[]> {
    return this.http.get<Objective[]>(`${this.apiUrl}/GetChildObjectives/${parentId}`);
  }



  addObjective(objective: Objective): Observable<Objective> {
    return this.http.post<Objective>(`${this.apiUrl}/AddObjective`, objective);
  }

  updateObjective(objective: Objective): Observable<Objective> {
    return this.http.put<Objective>(`${this.apiUrl}/UpdateObjective`, objective)
      .pipe(tap(item => {
        LmsService.objectiveUpdated$.next(objective);
        return item;
      }));
  }

  deleteObjective(objectiveId: number): Observable<Objective> {
    return this.http.delete<Objective>(`${this.apiUrl}/DeleteObjective/${objectiveId}`)
      .pipe(tap(item => {
        LmsService.objectiveDeleted$.next(objectiveId);
        return item;
      }));
  }

  getByIdWithCurriculumItemObjectives(objectiveId: number): Observable<Objective> {
    return this.http.get<Objective>(`${this.apiUrl}/GetByIdWithCurriculumItemObjectives/${objectiveId}`);
  }


  getBySubjectIdWithClassifications(subjectId: number): Observable<Objective[]> {
    return this.http.get<Objective[]>(
      `${this.apiUrl}/GetBySubjectIdWithClassifications/${subjectId}`);
  }


}
